import React from "react";
import { AuthConsumer } from "../../providers/authProvider";
import { LoadingScreen } from "../common";

export const Logout = () => (
  <AuthConsumer>
    {({ logout }) => {
      logout();
      return <LoadingScreen />;
    }}
  </AuthConsumer>
);
